import { render, staticRenderFns } from "./FrontPage.vue?vue&type=template&id=ebcf5c90&scoped=true"
var script = {}
import style0 from "./FrontPage.vue?vue&type=style&index=0&id=ebcf5c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcf5c90",
  null
  
)

export default component.exports